export const FeatureFlagActionConstants = {
    SET_FEATURE_FLAG: 'SET_FEATURE_FLAG'
};
